var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("main", { attrs: { role: "main" } }, [
    _c(
      "section",
      {
        staticClass: "splash font-raleway bg-blue",
        attrs: { id: "signin-container" },
      },
      [
        _c("div", { staticClass: "grid-container" }, [
          _c("div", { staticClass: "grid-x grid-margin-x" }, [
            _c("div", { staticClass: "signContainer" }, [
              _c(
                "div",
                {
                  staticClass: "tabs-content",
                  attrs: { "data-tabs-content": "tabs" },
                },
                [_c("div", { attrs: { id: "log-in" } }, [_c("SignInForm")], 1)]
              ),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }